/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Native_NoteInputs */

const en_mk_team_native_note = /** @type {(inputs: Mk_Team_Native_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires an installed agent and an account with access. Keep your computer awake.`)
};

const id_mk_team_native_note = /** @type {(inputs: Mk_Team_Native_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memerlukan agent terpasang dan akun yang mendukungnya. Komputer harus tetap menyala.`)
};

/**
* | output |
* | --- |
* | "Requires an installed agent and an account with access. Keep your computer awake." |
*
* @param {Mk_Team_Native_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_native_note = /** @type {((inputs?: Mk_Team_Native_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Native_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_native_note(inputs)
	return en_mk_team_native_note(inputs)
});